export enum RoomErrors {
  BLACKLIST_REASON = 'blacklist_reason',
  WHITELIST_REASON = 'whitelist_reason',
}

export const DENIED_REASON = {
  [RoomErrors.BLACKLIST_REASON]: 'blacklist',
  [RoomErrors.WHITELIST_REASON]: 'whitelist',
};
